import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const WEGE = ["Überweisung", "Inkasso", "Online-Shop / PayPal", "Bar", "Sonstiges"];
const heute = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Berlin" });

export const OnlineZahlungDialog = ({ item, onClose, onSaved }) => {
  const [datum, setDatum] = useState(heute());
  const [weg, setWeg] = useState("Überweisung");
  const [notiz, setNotiz] = useState("");
  const [laeuft, setLaeuft] = useState(false);

  useEffect(() => {
    if (item) {
      setDatum(heute());
      setWeg(item.mahnung_stufe >= 2 ? "Inkasso" : "Überweisung");
      setNotiz("");
    }
  }, [item]);

  const speichern = async () => {
    setLaeuft(true);
    try {
      await axios.post(`${API}/online-bestellungen/${item.id}/zahlung`, { bezahlt: true, bezahlt_am: datum, zahlungsweg: weg, notiz });
      toast.success(`Als bezahlt am ${datum.split("-").reverse().join(".")} eingetragen`);
      onSaved();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Speichern fehlgeschlagen");
    } finally { setLaeuft(false); }
  };

  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="online-zahlung-dialog">
        <DialogHeader><DialogTitle>Zahlungseingang erfassen</DialogTitle></DialogHeader>
        {item && (
          <div className="space-y-3 text-sm">
            <div className="text-stone-600">{item.rechnungsnummer} · {item.empfaenger_name} · {Number(item.endbetrag || 0).toLocaleString("de-DE")} €</div>
            <label className="block">Bezahlt am
              <input type="date" value={datum} max={heute()} onChange={(e) => setDatum(e.target.value)} data-testid="online-zahlung-datum"
                className="mt-1 w-full border border-stone-300 rounded px-2 py-1.5" />
            </label>
            <label className="block">Zahlungsweg
              <select value={weg} onChange={(e) => setWeg(e.target.value)} data-testid="online-zahlung-weg" className="mt-1 w-full border border-stone-300 rounded px-2 py-1.5">
                {WEGE.map((w) => <option key={w}>{w}</option>)}
              </select>
            </label>
            <label className="block">Notiz (optional)
              <input value={notiz} onChange={(e) => setNotiz(e.target.value)} placeholder="z. B. Inkasso-Abrechnung vom …" data-testid="online-zahlung-notiz"
                className="mt-1 w-full border border-stone-300 rounded px-2 py-1.5" />
            </label>
            <div className="flex justify-end gap-2 pt-2">
              <button onClick={onClose} className="px-3 py-1.5 rounded border border-stone-300" data-testid="online-zahlung-abbrechen">Abbrechen</button>
              <button onClick={speichern} disabled={laeuft || !datum} className="px-3 py-1.5 rounded bg-[#3D3835] text-white disabled:opacity-50" data-testid="online-zahlung-speichern">
                {laeuft ? "Speichert…" : "Als bezahlt speichern"}
              </button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
